
const util = require('util');

const _ = require('lodash');

const moment = require('moment');

const kv = require('knockout.validation');

const vb = require('./definition');

const {
	unwrapObservableAccessor,
} = require('./util');

const momentCoerce = (m, f) => {
	if (m instanceof moment) {
		return moment(m);
	}
	if (m instanceof Date) {
		return moment(m);
	}
	const parsed = moment(m, f, true);
	if (parsed.isValid()) {
		return parsed;
	}
	const parsedAsISO = moment(m, moment.ISO_8601, true);
	if (parsedAsISO.isValid()) {
		return parsedAsISO;
	}
	return parsed;
};

const momentUnwrapObservableAccessor = (m, f) => momentCoerce(unwrapObservableAccessor(m), f);


vb.DATE_FORMAT = 'DD.MM.YYYY';


vb.momentIsValid = (dateFormat, message) => {
	dateFormat = dateFormat || vb.DATE_FORMAT;
	return {
		validator: (v) => {
			if (!v) {
				return true;
			}
			const m = momentCoerce(v, dateFormat);
			return m.isValid();
		},
		message: message || ['Некорректная дата', 'исправьте'],
	};
};

function momentComparisonValidationBuilderFactory (methodName, message) {
	return (otherAccessor, dateFormat, overrideMessage) => {
		dateFormat = dateFormat || vb.DATE_FORMAT;
		return {
			validator: (v) => {
				const otherMoment = momentUnwrapObservableAccessor(otherAccessor, dateFormat);
				const m = momentCoerce(v, dateFormat);
				return !m.isValid()
					|| !otherMoment.isValid()
					|| m[methodName](otherMoment);
			},
			message: (params, observable) => {
				const otherMoment = momentUnwrapObservableAccessor(otherAccessor, dateFormat);
				const otherFormatted = otherMoment.format(dateFormat);

				params = _.isUndefined(params)
					? [otherFormatted, true]
					: [otherFormatted, ...params];

				return kv.formatMessage(
					overrideMessage || message,
					params,
					observable
				);
			},
		};
	};
}

vb.momentIsSameOrAfter = momentComparisonValidationBuilderFactory(
	'isSameOrAfter',
	'не ранее {0}'
);

vb.momentIsAfter = momentComparisonValidationBuilderFactory(
	'isAfter',
	'не ранее {0}'
);

vb.momentIsSameOrBefore = momentComparisonValidationBuilderFactory(
	'isSameOrBefore',
	'не позднее {0}'
);

vb.momentIsBefore = momentComparisonValidationBuilderFactory(
	'isBefore',
	'не позднее {0}'
);

vb.momentMaxAge = (options) => {
	const minMomentAccessor = () => {
		const { age, from } = unwrapObservableAccessor(options);
		const ageYears = unwrapObservableAccessor(age);
		const fromMoment = unwrapObservableAccessor(from);
		return fromMoment
			.clone()
			.subtract(ageYears, 'year');
	};
	return _.extend(vb.momentIsSameOrAfter(minMomentAccessor), {
		message: () => {
			const age = unwrapObservableAccessor(unwrapObservableAccessor(options).age);
			return util.format('не старше %s лет', age);
		},
	});
};

vb.momentMinAge = (options) => {
	const maxMomentAccessor = () => {
		const { age, from } = unwrapObservableAccessor(options);
		const ageYears = unwrapObservableAccessor(age);
		const fromMoment = unwrapObservableAccessor(from);
		return fromMoment
			.clone()
			.subtract(ageYears, 'year');
	};
	return _.extend(vb.momentIsSameOrBefore(maxMomentAccessor), {
		message: () => {
			const age = unwrapObservableAccessor(unwrapObservableAccessor(options).age);
			return age === 1
				? util.format('не моложе %s года', age)
				: util.format('не моложе %s лет', age);
		},
	});
};
